import React, { Component } from "react";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";

class FilterCDB extends Component {
  getValue = (name) => {
    if (name === "pekerjaan1" || name === "pekerjaan2") {
      const selectedValues =
        this.props.state.filterData?.filterCDB?.[name] || [];
      return selectedValues
        .map((val) =>
          this.props.options.jobOptions.find((opt) => opt.value === val)
        )
        .filter(Boolean);
    } else {
      return this.props.state.filterData?.filterCDB?.[name] || "";
    }
  };

  setValue = (name, value) => {
    this.props.onValueChange("filterCDB", name, value);
  };

  render() {
    const { options } = this.props;
    return (
      <>
        <SimpleInput
          id="input_text_nama"
          name="nama"
          label="Nama"
          value={this.getValue("nama")}
          onChange={({ target }) => this.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_nik"
          name="nik"
          label="NIK"
          value={this.getValue("nik")}
          onChange={({ target }) => this.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_no_hp_1"
          name="noHp1"
          label="No HP 1"
          value={this.getValue("noHp1")}
          onChange={({ target }) => this.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_no_hp_2"
          name="noHp2"
          label="No HP 2"
          value={this.getValue("noHp2")}
          onChange={({ target }) => this.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_address"
          name="alamat"
          label="Alamat"
          value={this.getValue("alamat")}
          onChange={({ target }) => this.setValue(target.name, target.value)}
        />
        <SimpleDDL
          id="select_options_agama"
          box="search"
          name="agama"
          label="Agama"
          isClearable
          options={options.religionOptions}
          value={this.getValue("agama")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        {/* <SimpleInput
                    id="input_text_job1"
                    name="pekerjaan1"
                    label="Pekerjaan 1"
                    value={this.getValue("pekerjaan1")}
                    onChange={({ target }) => this.setValue(target.name, target.value)}
                /> */}
        <SimpleDDL
          id="select_option_pekerjaan_1"
          box="multiselect"
          name="pekerjaan1"
          label="Pekerjaan 1"
          isClearable
          options={options.jobOptions}
          value={this.getValue("pekerjaan1")}
          // onChange={(value, {name}) => this.setValue(name, value)}
          onChange={(selectedOptions, { name }) => {
            const onlyValues = selectedOptions?.map((item) => item.value);
            this.setValue(name, onlyValues);
          }}
        />
        {/* <SimpleInput
                    id="input_text_job2"
                    name="pekerjaan2"
                    label="Pekerjaan 2"
                    value={this.getValue("pekerjaan2")}
                    onChange={({ target }) => this.setValue(target.name, target.value)}
                /> */}
        <SimpleDDL
          id="select_option_pekerjaan_2"
          box="multiselect"
          name="pekerjaan2"
          label="Pekerjaan 2"
          isClearable
          options={options.jobOptions}
          value={this.getValue("pekerjaan2")}
          onChange={(selectedOptions, { name }) => {
            const onlyValues = selectedOptions?.map((item) => item.value);
            this.setValue(name, onlyValues);
          }}
        />
        <SimpleDDL
          id="select_options_gender"
          box="search"
          name="jenisKelamin"
          label="Jenis Kelamin"
          isClearable
          options={options.genderOptions}
          value={this.getValue("jenisKelamin")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleInput
          id="input_text_kk"
          name="noKK"
          label="Nomor KK"
          value={this.getValue("noKK")}
          onChange={({ target }) => this.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_npwp"
          name="npwp"
          label="NPWP"
          value={this.getValue("npwp")}
          onChange={({ target }) => this.setValue(target.name, target.value)}
        />
        <SimpleDDL
          id="select_options_province"
          box="search"
          name="province"
          label="Provinsi"
          isClearable
          options={options.provinceOptions}
          value={this.getValue("province")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_kabkot"
          box="search"
          name="kabkot"
          label="Kota/Kabupaten"
          options={options.kabkotOptions}
          isClearable
          value={this.getValue("kabkot")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_kecamatan"
          box="search"
          name="kecamatan"
          label="Kecamatan"
          options={options.kecamatanOptions}
          isClearable
          value={this.getValue("kecamatan")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_kelurahan"
          box="search"
          name="kelurahan"
          label="Kelurahan"
          options={options.kelurahanOptions}
          isClearable
          value={this.getValue("kelurahan")}
          // onChange={(value, { name }) => this.setValue(name, value)}
          onChange={(value, { name }) => {
            this.setValue(name, value);
            this.setValue("kodePos", null);
          }}
        />
        <SimpleDDL
          id="select_options_zip_code"
          box="search"
          name="kodePos"
          label="Kode Pos"
          options={options.zipCodeOptions}
          isClearable
          value={this.getValue("kodePos")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleInput
          id="input_text_member_id"
          name="memberId"
          label="Member ID"
          value={this.getValue("memberId")}
          onChange={({ target }) => this.setValue(target.name, target.value)}
        />
        <SimpleDDL
          id="select_options_member_level"
          box="search"
          name="memberLevel"
          label="Member Level"
          options={options.levelOptions}
          isClearable
          value={this.getValue("memberLevel")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_loyalty_level"
          box="search"
          name="loyaltyLevel"
          label="Loyalty Level"
          options={options.loyaltyOptions}
          isClearable
          value={this.getValue("loyaltyLevel")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_facebook"
          box="search"
          name="facebook"
          label="Facebook"
          options={options.socMedOptions}
          isClearable
          value={this.getValue("facebook")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_instagram"
          box="search"
          name="instagram"
          label="Instagram"
          options={options.socMedOptions}
          isClearable
          value={this.getValue("instagram")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_linkedin"
          box="search"
          name="linkedin"
          label="LinkedIn"
          options={options.socMedOptions}
          isClearable
          value={this.getValue("linkedin")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_twitter"
          box="search"
          name="x"
          label="X (Twitter)"
          options={options.socMedOptions}
          isClearable
          value={this.getValue("x")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_tiktok"
          box="search"
          name="tiktok"
          label="TikTok"
          options={options.socMedOptions}
          isClearable
          value={this.getValue("tiktok")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_hobby"
          box="multiselect"
          name="hobby"
          label="Hobby"
          options={options.hobbyOptions}
          isClearable
          value={this.getValue("hobby")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_interest"
          box="multiselect"
          name="interest"
          label="Interest"
          options={options.interestOptions}
          isClearable
          value={this.getValue("interest")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_disc"
          box="search"
          name="kategoriDisc"
          label="Kategori DISC"
          options={options.kategoriDiscOptions}
          isClearable
          value={this.getValue("kategoriDisc")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleDDL
          id="select_options_kategori_khusus"
          box="search"
          name="kategoriKhusus"
          label="Kategori Khusus"
          options={options.specialCategoryOptions}
          isClearable
          value={this.getValue("kategoriKhusus")}
          onChange={(value, { name }) => this.setValue(name, value)}
        />
        <SimpleInput
          id="input_text_catatan_khusus"
          name="catatanKhusus"
          label="Catatan Khusus"
          value={this.getValue("catatanKhusus")}
          onChange={({ target }) => this.setValue(target.name, target.value)}
        />
      </>
    );
  }
}

export default FilterCDB;
